<div class="background-white cows h-100">
    @if (render()) {
        <router-outlet />
    }
</div>
